import styled from 'styled-components';

import { Button, Props as ButtonProps } from 'atoms/buttons/Button';
import { mobileAndAbove, tabletAndAbove } from 'style/mediaQuery';

const StyledButton = styled(Button)`
  @media ${mobileAndAbove} {
    width: auto;
  }

  @media ${tabletAndAbove} {
    width: auto;
    max-width: 100%;
  }
`;

export const LineupActionCta = (props: Omit<ButtonProps, 'size'>) => (
  <StyledButton size="medium" {...props} />
);
